import React from "react";
import RoundTracker from "./RoundTracker";

const GameHeader = ({
  roundNumber,
  maxRounds = 10,
  currentPhase,
  name,
  playerCash,
  playerNetWorths = {},
  actionsRemaining = {},
  maxActionsPerTurn = 3,
  maxActionsThisTurn = {},
  myTurn,
  endTurnHandler,
  endGame,
  onStartTutorial,
  turnTimeRemaining,
  turnTimerPlayer,
  turnTimerTotal,
}) => {
  const maxForTurn = maxActionsThisTurn[name] ?? maxActionsPerTurn;

  return (
    <div className="game-header">
      {/* Round Tracker with Action Buttons */}
      <RoundTracker 
          roundNumber={roundNumber} 
          maxRounds={maxRounds}
          myTurn={myTurn}
          onEndTurn={endTurnHandler}
          onEndGame={endGame}
          onStartTutorial={onStartTutorial}
          playerName={name}
          cash={playerCash[name] || 0}
          netWorth={playerNetWorths[name] || 0}
          actionsRemaining={actionsRemaining[name] || 0}
          maxActionsPerTurn={maxForTurn}
        />

      {/* Game Phases */}
      <div className="game-phases-compact" data-tutorial="game-phases">
        <div className={`game-phase-compact ${currentPhase === 'stock_options' ? 'active' : ''}`}>
          📊 Stock Options
        </div>
        <div className="game-phase-separator-compact">→</div>
        <div className={`game-phase-compact ${currentPhase === 'events' ? 'active' : ''}`}>
          📰 Events
        </div>
        <div className="game-phase-separator-compact">→</div>
        <div className={`game-phase-compact ${currentPhase === 'trading' ? 'active' : ''}`}>
          💼 Trading
        </div>
        <div className="game-phase-separator-compact">→</div>
        <div className={`game-phase-compact ${currentPhase === 'end_of_round' ? 'active' : ''}`}>
          🎲 End of Round
        </div>
      </div>
    </div>
  );
};

export default GameHeader;

